import { render, staticRenderFns } from "./LateArrivalReport.vue?vue&type=template&id=4b53a77c"
import script from "./LateArrivalReport.vue?vue&type=script&lang=js"
export * from "./LateArrivalReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports